import type { EcosystemHeadCorridorCardData } from "@/components/ecosystem-head/EcosystemHeadCorridorCard";
import { ecosystemHeadProfileHref } from "@/pages/ecosystem-heads/ecosystemHeads.const";
import type { DiscoverFeaturedCorridor } from "@/pages/discover/hooks/useDiscoverFeaturedCorridors";
import type { SectorEcosystemCorridorHead } from "@shared/sectorEcosystemOverview";

export function discoverCorridorToCardData(corridor: DiscoverFeaturedCorridor): EcosystemHeadCorridorCardData {
  return {
    id: corridor.ecosystemHeadUserId,
    name: corridor.name,
    corridorName: corridor.corridorName,
    managedCompanyCount: corridor.managedCompanyCount,
    ecosystemIndustry: corridor.industry,
    ecosystemCountry: corridor.country,
    ecosystemTargetCountry: corridor.targetCountry,
    corridorLabel: corridor.corridorLabel,
    expertiseTags: corridor.expertiseTags,
    ecosystemHeadSummary: corridor.summary,
    ecosystemHeadLiveFrom: corridor.liveFrom,
    profileStatus: corridor.profileStatus ?? "LIVE",
    linkStatus: null,
    logoUrl: corridor.logoUrl ?? null,
  };
}

export function sectorCorridorToCardData(corridor: SectorEcosystemCorridorHead): EcosystemHeadCorridorCardData {
  return {
    id: corridor.ecosystemHeadUserId,
    name: corridor.name,
    corridorName: corridor.corridorName,
    managedCompanyCount: corridor.managedCompanyCount,
    ecosystemIndustry: corridor.industry,
    ecosystemCountry: corridor.country,
    ecosystemTargetCountry: corridor.targetCountry,
    corridorLabel: corridor.corridorLabel,
    expertiseTags: corridor.expertiseTags,
    ecosystemHeadSummary: corridor.ecosystemHeadSummary ?? null,
    ecosystemHeadLiveFrom: corridor.liveFrom ?? null,
    profileStatus: corridor.profileStatus,
    linkStatus: null,
    logoUrl: corridor.logoUrl ?? null,
  };
}

export function sectorCorridorProfileHref(corridor: SectorEcosystemCorridorHead): string {
  return ecosystemHeadProfileHref(corridor.industry, corridor.ecosystemHeadUserId);
}
